<template>
  <v-dialog
    v-model="dialog"
    max-width="800"
    persistent
  >
    <v-card>
      <v-card-title>
        {{ $t('label.representacao_conjunto') }} - {{ grupo ? grupo.nomExtensao : '' }}
      </v-card-title>

      <v-divider />

      <v-card-text>
        <usuario-form-grupo-rep-conjunto
          v-if="grupo"
          :id-grupo-fornecedor="grupo.id"
        />
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          @click="fechar"
        >
          {{ $t('label.fechar') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import UsuarioFormGrupoRepConjunto from '@/spa/usuario/UsuarioFormGrupoRepConjunto';

export default {
  name: 'UsuarioFornecedorRepresentacaoConjuntoDialog',
  components: {
    UsuarioFormGrupoRepConjunto,
  },
  data() {
    return {
      dialog: false,
      grupo: null,
    };
  },
  methods: {
    open(grupoSelecionado) {
      this.grupo = grupoSelecionado;
      this.dialog = true;
    },
    fechar() {
      this.dialog = false;
      this.grupo = null;
    },
  },
};
</script>

<style scoped>
</style>
